import { useFormikContext } from 'formik'
import React from 'react'

import Button from '../Button'

interface Props {
  title: string
  [otherProps: string]: any
}

const SubmitButton: React.FC<Props> = ({ title, ...otherProps }) => {
  const { handleSubmit } = useFormikContext()

  const handleClick: React.MouseEventHandler<HTMLButtonElement> | undefined = () => {
    handleSubmit()
  }

  return (
    <Button {...otherProps} onClick={handleClick}>
      {title}
    </Button>
  )
}

export default SubmitButton
